<template lang="pug">
el-form-item(:label="label")
  el-select(v-bind="$attrs", v-model="fieldId", filterable, clearable)
    el-option(v-for="{ columnDisplayName, columnName } in list", :key="columnName", :label="columnDisplayName", :value="columnName")
</template>
<script>
const cache = {};
import service from "@/CommonDP/service/metadata-service.js";
export default {
  inheritAttrs: false,
  props: {
    value: { default: undefined, type: [String, Array] },
    tableId: { default: "", type: String },
    label: { default: "模型字段", type: String }
  },
  data() {
    return { cache, list: [] };
  },
  computed: {
    fieldId: {
      get() {
        return this.value;
      },
      set(newName) {
        this.$emit("input", newName || "");
      }
    }
  },
  watch: {
    tableId(tableId) {
      this.list = [];
      this.fieldId = undefined;
      this.getList(tableId);
    }
  },
  created() {
    this.getList(this.tableId);
  },
  methods: {
    async getList(tableId) {
      if (!tableId) return;
      const oldFn = cache[tableId];
      const promise = oldFn || service.columnList(tableId);
      if (!oldFn) cache[tableId] = promise;
      const { data } = await promise;
      if (tableId === this.tableId) this.list = data;
    }
  }
};
</script>
